<template>
  <b-container fluid>
    <b-row id="tableId">
      <div class="my-1 column3">
        <h5 class="mb-0">
          {{ $t("Продажа реeстер")}}
        </h5>
      </div>
      <!-- <b-col xs="12" md="12" lg="12" xl="12" class="px-0">
        <h5 class="mb-0">{{ $t("Продажа реeстер")}}</h5>
      </b-col> -->
      <div class="my-1 column3">
        <label for="">{{ $t("Вақт") }} 1</label>
        <input class="defaultinput" type="date" v-model="datas.date1" />
      </div>
      <div class="my-1 column3">
        <label for="">{{ $t("Вақт") }} 2</label>
        <input class="defaultinput" type="date" v-model="datas.date2" />
      </div>
      <div class="my-1 column3">
        <label>Склад</label>
        <v-select class="form-control-sm md-input" :options="skladlist" @input="Send(),Userlist()" :disabled="skladhave"
          v-model="datas.sklad_id" :reduce="name => name.id" label="name" :clearable="false">
          <template #search="{ attributes, events }">
            <input class="vs__search" v-bind="attributes" v-on="events" aria-activedescendant="null" />
          </template>
          <template v-slot:no-options="{ search, searching }">
            <template v-if="searching">
              <em><b>{{ search }}</b></em>
              {{ $t("бўйича маьлумот йўқ") }}
            </template>
            <em style="opacity: 0.5" v-else>{{ $t("Маьлумот йўқ") }}</em>
          </template>
        </v-select>
      </div>
      <div class="my-1 column2">
        <label for="">Группа клиент</label>
        <v-select :clearable="true" class="form-control-sm md-input" :options="kontragentfolder" v-model="datas.folder"
          :reduce="(name) => name.id" label="name">
        </v-select>
      </div>
      <div class="my-1 column2">
        <label>Клиент</label>
        <v-select class="form-control-sm md-input" :options="kontragentlist" @input="Send()"
          v-model="datas.kontragent_id" :reduce="name => name.id" label="name" :clearable="true">
        </v-select>
      </div>
      <div class="my-1 column2">
        <label for="">Группа товар</label>
        <v-select :clearable="true" class="form-control-sm md-input" :options="productfolder" v-model="datas.folderpr"
          :reduce="(name) => name.id" label="name">
        </v-select>
      </div>
      <div class="my-1 column2">
        <label>Товар</label>
        <v-select class="form-control-sm md-input" :options="productlist" @input="Send()" v-model="datas.product_id"
          :reduce="extra_name => extra_name.id" label="extra_name" :clearable="true">
        </v-select>
      </div>
      <div class="my-1 column2">
        <label>{{$t('Тўлов тури')}}</label>
        <v-select class="form-control-sm md-input" :options="paytypelist" @input="Send()" v-model="datas.pay_type_id"
          :reduce="name => name.id" label="name" :clearable="true">
        </v-select>
      </div>
      <div class="my-1 column2">
        <label>{{$t('Фойдаланувчи')}}</label>
        <v-select class="form-control-sm md-input" :options="userlist" @input="Send()" v-model="datas.user_id"
          :reduce="username => username.id" label="username" :clearable="true">
        </v-select>
      </div>
      <div class="my-1 column1">
        <label>{{$t('Деталка')}}</label>
        <input type="checkbox" v-model="checkbox">
      </div>
      <div class="my-1">
        <br>
        <button type="button" class="btn mybtn" @click="Send()">
          {{ $t("Кўриш") }}
        </button>
        <!-- <button type="button" class="btn mybtn" @click="Print2()">
          <b-icon icon="printer"></b-icon>
        </button> -->
        <button type="button" class="btn mybtn" @click="downloadExl">
          <b-icon icon="cloud-download"></b-icon> Excel
        </button>
      </div>
      <CloudSyncButton v-if="inSync==true" style="width: 100%;" :title="syncProgress+'%'" :titleDone="syncProgress+'%'"
        :syncProgress="syncProgress" :inSync="inSync"
        :styling="{loadColor: '#81d427',strokeColor: '#fff',btnColor: '#aaa'}" />
      <span v-if="results[0] != null" id="oldtable">
        <md-card>
          <md-card-content>
            <table class="table table-bordered" style="font-size: 12px;">
              <thead class="thead-light" :style="checkbox==true?'':'width: 100%!important;'">
                <tr>
                  <th class="column0">№</th>
                  <th class="column4">{{ $t("Документ") }}</th>
                  <th class="column2">Клиент</th>
                  <th class="column2">Телефон</th>
                  <th class="column2">Валюта</th>
                  <th class="column2">{{$t('Тип цена')}}</th>
                  <th class="column2">Сумма</th>
                  <th class="column2">Скидка</th>
                  <th class="column2">{{$t('Тўлов')}} сумма</th>
                  <th class="column2">{{$t('Насия')}}</th>
                  <th class="column4">Комментарий</th>
                  <th class="column2">{{$t('Фойдаланувчи')}}</th>
                </tr>
              </thead>
              <tbody style="overflow: hidden;height: auto;">
                <!-- <VueAutoVirtualScrollList :totalHeight="550" :defaultHeight="50" style="width: 100%!important;height: calc(100vh - 200px);"> -->
                <div style="height: calc(100vh - 300px);">
                  <span v-for="(item, index) in results" :key="index">
                    <tr :style="{ height: `${index / 1000 + 20}px` }" class="row100 body" style="cursor:pointer"
                      @click="ChiqimUpdate(item.id)">
                      <td class="column0">{{index+1}}</td>
                      <td class="column4">{{$t('Чиқим')+" №"+item.id }} {{SetDatetime(item.created_at)}}</td>
                      <td class="column2"><span v-if="item.kontragent!=undefined">{{ item.kontragent.name}}</span></td>
                      <td class="column2"><span v-if="item.kontragent!=undefined">{{"'"+item.kontragent.phone_number}}</span></td>
                      <td class="column2" style="text-align: center;">{{ item.pay_type.name }}</td>
                      <td class="column2" style="text-align: center;">{{ $t(item.price_type) }}</td>
                      <td class="column2 kol">{{ item.summa|numFormats}}</td>
                      <td class="column2 kol">{{ item.skidka_summa|numFormats}}</td>
                      <td class="column2 kol">{{ item.summa-item.skidka_summa|numFormats}}</td>
                      <td class="column2 kol">{{ nasiya(item)|numFormats}}</td>
                      <td class="column4">{{ item.comment}}</td>
                      <td class="column2"><span v-if="item.user!=null">{{ item.user.first_name}}</span></td>
                    </tr>
                    <span v-if="checkbox==true" class="childrester">
                      <tr>
                        <th class="column0">№</th>
                        <th class="column4">{{$t('Товар')}}</th>
                        <th class="column1">{{$t('Ўлчов бирлик')}}</th>
                        <th class="column1">{{$t('Сони')}}</th>
                        <th class="column2">{{$t('Қолдиқ')}}</th>
                        <th class="column2">{{$t('Нарх')}}</th>
                        <th class="column2">Сумма</th>
                      </tr>
                      <tr v-for="(item1, index1) in item.rasxod_table" :key="index1">
                        <td class="column0">{{index1+1}}</td>
                        <td class="column4">
                          <span v-if="item1.product!=null">
                            {{item1.product.extra_name}}
                          </span>
                        </td>
                        <td class="column1">{{ item1.product.unit != null ? item1.product.unit.name : "" }}</td>
                        <td class="column1 kol">{{item1.count}}</td>
                        <td class="column2 kol">{{item1.current_balance}}</td>
                        <td class="column2 kol">{{item1.price}}</td>
                        <td class="column2 kol">{{item1.summa}}</td>
                      </tr>
                    </span>
                  </span>
                </div>
                <!-- </VueAutoVirtualScrollList> -->
              </tbody>
              <thead class="thead-light spesific">
                <tr>
                  <th rowspan="2" colspan="5" style="width: 52.5%;text-align: left!important;">{{$t('Жами')}}</th>
                  <th class="column2 kol">{{summ.summ | numFormats}}
                  </th>
                  <th rowspan="2" class="kol column2">{{summ.skidka | numFormats}}</th>
                  <th class="kol column2">{{summ.oplatasumm | numFormats}}
                  </th>
                  <th class="kol column2">{{summ.nasiya | numFormats}}
                  </th>
                  <th rowspan="2" class="column4">Товар сумма</th>
                  <th class="column2 kol">{{summ.product_summa|numFormats}}</th>
                </tr>
                <tr>
                  <th class="kol column2">
                    ${{summ.summ_dollar | numFormats}}
                  </th>
                  <th class="kol column2">
                    ${{summ.oplatasumm_dollar|numFormats}}
                  </th>
                  <th class="kol column2">
                    ${{summ.nasiya_dollar|numFormats}}
                  </th>
                  <th class="kol column2">
                    ${{summ.product_summa_dollar|numFormats}}
                  </th>
                </tr>
                {{$t('Сони')}} {{$t('продажа')}} <b>{{results.length}}</b>
              </thead>
            </table>
          </md-card-content>
        </md-card>
      </span>
    </b-row>
    <sklad :datas="datas"></sklad>
    <paytype :datas="datas"></paytype>
    <kontragent :datas="datas"></kontragent>
  </b-container>
</template>

<script>
  var XLSX = require("xlsx");
  import ZkTable from 'vue-table-with-tree-grid';
  var FileSaver = require("file-saver");
  import VueAutoVirtualScrollList from "vue-auto-virtual-scroll-list";
  import $ from "jquery";
  import { print } from "../../../components/mixins/print.js";
  import { Sklad, Paytype, Kontragent } from "@/pages";
  import CloudSyncButton from "@vuesence/cloud-sync-button";
  export default {
    components: { Sklad, ZkTable, VueAutoVirtualScrollList, CloudSyncButton, Kontragent, Paytype },
    mixins: [print],
    data() {
      return {
        checkbox: true,
        datas: {
          date1: new Date().toISOString().slice(0, 8) + "01",
          date2: new Date().toISOString().slice(0, 10),
          sklad_id: parseInt(localStorage.getItem("sklad_id")),
          product_id: null,
          pay_type_id: null,
          user_id: null,
          kontragent_id: null,
          folder: null,
          folderpr: null

        },
        summ: { summ: 0, skidka: 0,nasiya:0,nasiya_dollar:0,oplatasumm: 0, summ_dollar: 0, oplatasumm_dollar: 0,product_summa:0,product_summa_dollar:0},
        sklad: "",
        skladlist: [],
        paytypelist: [],
        productlist: [],
        kontragentfolder: [],
        productfolder: [],
        kontragentlist: [],
        userlist: [],
        results: []
      };
    },
    mounted() {
      this.Kontragentfolder();
      this.Productfolder();
    },
    created() {
      let self = this;
      self.$root.$on("skladone", function (getdata) {
        self.sklad = getdata;
      });
      self.$root.$on("skladall", function (getdata) {
        self.skladlist = getdata;
      });
      self.$root.$on("kontragentall", function (getdata) {
        self.kontragentlist = getdata;
      });
      self.$root.$on("paytypeall", function (getdata) {
        self.paytypelist = getdata;
      });
      self.Userlist();
    },
    methods: {
      nasiya(item) {
        var data = 0;
        if (item.pay_type_id == 3) {
          data =item.summa-item.skidka_summa- (item.cash_summa / item.dollar_rate + item.plastic_summa / item.dollar_rate + item.shot_summa / item.dollar_rate + item.dollar_summa - item.refund_money / item.dollar_rate + item.refund_money_dollar);
        } else {
          data =item.summa-item.skidka_summa- (item.cash_summa + item.plastic_summa + item.shot_summa + item.dollar_summa * item.dollar_rate - item.refund_money - item.refund_money_dollar * item.dollar_rate);
        }
        return data;
      },
      Kontragentfolder() {
        let self = this;
        axios({
          method: "get",
          url: "api/v1/kontragent/folder-list",
        }).then(function (response) {
          self.kontragentfolder = response.data;
        });
      },
      Productfolder() {
        let self = this;
        axios({
          method: "get",
          url: "api/v1/product/folder-list",
        }).then(function (response) {
          self.productfolder = response.data;
        });
      },
      SetSumm() {
        let self = this;
        self.summ.summ=0;
        self.summ.oplatasumm=0;
        self.summ.summ_dollar=0;
        self.summ.oplatasumm_dollar=0;
        self.summ.skidka=0;
        self.summ.nasiya=0;
        self.summ.nasiya_dollar=0;
        self.summ.product_summa=0;
        self.summ.product_summa_dollar=0;
        self.results.forEach(function (item, value) {
          if (item.pay_type_id != 3) {
            self.summ.summ += item.summa;
            self.summ.nasiya+=self.nasiya(item);
            self.summ.oplatasumm += (item.summa - item.skidka_summa);
          } else {
            self.summ.nasiya_dollar+=self.nasiya(item);
            self.summ.summ_dollar += item.summa;
            self.summ.oplatasumm_dollar += (item.summa - item.skidka_summa);
          }
          item.rasxod_table.forEach(function(value1,index2){
          if (item.pay_type_id != 3) {
            self.summ.product_summa += value1.summa;
          }else{
            self.summ.product_summa_dollar += value1.summa;
          }
          });
          self.summ.skidka += item.skidka_summa;
        });
      },
      Userlist() {
        let self = this;
        axios
          .get("api/v1/users/usernames/" + self.datas.sklad_id)
          .then(function (response) {
            self.userlist = response.data;
          });
      },
      Format: function (field, data, column) {
        return this.$options.filters.numFormat0(data[field]);
      },
      async Print2() {
        var head = $(".md-toolbar-section-start").html();
        if (head == undefined) {
          head = "";
        }
        var s = $(".content input")
          .eq(0)
          .val();
        var s1 = $(".content input")
          .eq(1)
          .val();
        var table = this.Table();
        window.document.body.innerHTML = head + table;
        $("input")
          .eq(0)
          .val(s);
        $("input")
          .eq(1)
          .val(s1);
        window.print();
        window.location.reload();
      },
      // Excel() {
      //   $("#oldtable").html(this.Table());
      //   let wb = XLSX.utils.table_to_book(
      //       document.getElementById("oldtable")
      //     ),
      //     wopts = {
      //       bookType: "xlsx",
      //       bookSST: false,
      //       type: "binary"
      //     },
      //     wbout = XLSX.write(wb, wopts);
      //   FileSaver.saveAs(
      //     new Blob([this.s2ab(wbout)], {
      //       type: "application/octet-stream;charset=utf-8"
      //     }),
      //     new Date() + "tovarxisobot.xlsx"
      //   );
      //   // self.Send();
      //    setTimeout(() => {
      //     window.location.reload();
      //    }, 2000);
      // },
      downloadExl() {
        this.$store.state.xls=true;
        setTimeout(() => {
          let wb = XLSX.utils.table_to_book(document.getElementById("oldtable")),
          wopts = {
            bookType: "xlsx",
            bookSST: false,
            type: "binary"
          };
        var wscols = [{ width: 5 }, { width: 30 }, { width: 18 }, { width: 18 },{ width: 18 }, { width: 18 }, {width: 15,}, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }, { width: 13 }];
        wb.Sheets.Sheet1['!cols'] = wscols;
        let wbout = XLSX.write(wb, wopts);
        FileSaver.saveAs(
          new Blob([this.s2ab(wbout)], {
            type: "application/octet-stream;charsetted=utf-8"
          }),
          new Date() + "chiqim_reester.xlsx"
        );
        setTimeout(() => {
          this.$store.state.xls=false;
        }, 3000);
        }, 1000);
      },
      s2ab(s) {
        if (typeof ArrayBuffer !== "undefined") {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
          return buf;
        } else {
          var buf = new Array(s.length);
          for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xff;
          return buf;
        }
      },
      Clicked(id) {
        localStorage.setItem("date1", this.datas.date1);
        localStorage.setItem("date2", this.datas.date2);
        localStorage.setItem("product_id", id);
        localStorage.setItem("sklad_id", this.datas.sklad_id);
        let routeData = this.$router.resolve({ path: "/xisobot/sverka/product" });
        window.open(routeData.href, "_blank");
      },
      ChiqimUpdate(id) {
        let UpdateWindow;
        UpdateWindow = window.open(
          "#/chiqim/update/" + id,
          "_blank",
          "width=1000, height=1000"
        );
      },
      Send() {
        let self = this;
        self.startSync();
        self.results = [];
        var datas = {
          datetime1: parseInt(new Date(self.datas.date1).valueOf().toString().slice(0, 10)),
          datetime2: parseInt(new Date(self.datas.date2).valueOf().toString().slice(0, 10)) + 86399,
          sklad_id: self.datas.sklad_id,
          user_id: self.datas.user_id,
          kontragent_id: self.datas.kontragent_id,
          pay_type_id: self.datas.pay_type_id,
          product_id: self.datas.product_id,
          folder: self.datas.folder,
          folderpr: self.datas.folderpr
        };
        self.summ.summ = 0;
        self.summ.oplatasumm = 0;
        self.summ.skidka = 0;
        var url = 'api/v1/report/reestr-rasxod';
        axios({
          method: "post",
          url: url,
          data: datas,
          onUploadProgress: function (progressEvent) {
            this.syncProgress = 40;
          }.bind(this)
        }
        ).then(function (response) {
          self.results = response.data;
          self.SetSumm();
          // self.Jami();
          self.syncProgress = 100;
        });
      }
    }
  };
</script>
<style>
  .spesific .kol {
    text-align: right !important;
  }

  .spesific .left {
    text-align: left !important;
  }

  .spesific {
    width: calc(100% - 9px) !important;
  }

  /* .zk-table__body-cell:nth-child(3),.zk-table__body-cell:nth-child(5),.zk-table__body-cell:nth-child(7),.zk-table__body-cell:nth-child(9){
    text-align: end!important;
  }
  .zk-table__body-row{
    height: auto!important;
  }
  .zk-table{
    font-size: 14px!important;
  }
  .zk-table__cell-inner{
    padding: 5px!important;
  }
  .zk-table {
    line-height: 14px!important;
  }
  .zk-table td{
    padding: 0!important;
  }
  .zk-table__header{
    width: calc(100% - 12px)!important;
  }
  .zk-table th{
    background-color:rgb(186 225 225)!important;
  }
  .spesific td{
    background-color:rgb(186 225 225)!important;
  }
  .zk-table__body-cell, .zk-table__footer-cell, .zk-table__header-cell{
    word-break: keep-all!important;
    border-right: 1px solid #aaa;
  }
  .zk-table__body{
    display: block!important;
  height: 62vh !important;
  overflow: auto !important;
 }  */
</style>
<style scoped>
  .my-1 {
    padding-right: 10px !important;
  }

  /* * {
    margin: 0;
    padding: 0;
  } */
  /* .switch-list {
    margin: 20px 0;
    list-style: none;
    overflow: hidden;
  }
  .switch-item {
    margin: 20px;
    float: left;
  } */
  /* .zk-table__body tbody {
  height: 28vh !important;
  overflow: auto !important; */
  /* } */

  /* .btn.btn-secondary {
  float: right !important;
  padding: 2px 9px !important;
} */

  .second>tr {
    background: #c0c0c03d;
  }

  .first>tr {
    font-weight: bold;
    background: rgb(211, 209, 208);
  }

  .spesific td {
    font-weight: bold;
    font-size: 14px;
  }

  .spesific {
    background-color: antiquewhite;
  }
</style>